const state = {
	items: []
}
const mutations = {
	SET_SEARCH_ITEMS: (state, payload) => {
		state.items = payload;
	},
}

const actions = {
	setSearchItems({ commit }, payload) {
		commit('SET_SEARCH_ITEMS', payload)
	},
}

const getters = {
	searchItems: state => state.items
}

export default {
	state,
	mutations,
	actions,
	getters
}


// WEBPACK FOOTER //
// ./src/store/module/search.js